export default "__VITE_ASSET__DOfxDH9J__"